import { axios } from '@/utils/request'

/**
 * 查询草药信息表
 *
 * @author liwei
 * @date 2022-06-12 17:24:51
 */
export function baHerbalMedicinePage (parameter) {
  return axios({
    url: '/baHerbalMedicine/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 草药信息表列表
 *
 * @author liwei
 * @date 2022-06-12 17:24:51
 */
export function baHerbalMedicineList (parameter) {
  return axios({
    url: '/baHerbalMedicine/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加草药信息表
 *
 * @author liwei
 * @date 2022-06-12 17:24:51
 */
export function baHerbalMedicineAdd (parameter) {
  return axios({
    url: '/baHerbalMedicine/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑草药信息表
 *
 * @author liwei
 * @date 2022-06-12 17:24:51
 */
export function baHerbalMedicineEdit (parameter) {
  return axios({
    url: '/baHerbalMedicine/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除草药信息表
 *
 * @author liwei
 * @date 2022-06-12 17:24:51
 */
export function baHerbalMedicineDelete (parameter) {
  return axios({
    url: '/baHerbalMedicine/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出草药信息表
 *
 * @author liwei
 * @date 2022-06-12 17:24:51
 */
export function baHerbalMedicineExport (parameter) {
  return axios({
    url: '/baHerbalMedicine/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 字典表
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailList (parameter) {
  return axios({
    url: '/baDatadictDetail/list',
    method: 'get',
    params: parameter
  })
}

